(function iife() {
	"use strict";

	angular.module("dx.webapp.navigation").component("dxNavigationAction", {
		bindings: {
			targetRoute: "@",
			icon: "@",
			isActiveMenuItem: "<",
			label: "@",
			targetRouteParameters: "<",
		},
		templateUrl: "tmpl/navigation/navigation-action-component.html",
		controller: "dxNavigationActionController",
		controllerAs: "vm",
	});
}());
